var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPicture = function SvgPicture(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 28,
    viewBox: "0 0 33 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 2C20.9375 2 21.125 2.1875 21.1875 2.375L22.5625 6H29.5C30 6 30.5 6.5 30.5 7V25C30.5 25.5625 30 26 29.5 26H3.5C2.9375 26 2.5 25.5625 2.5 25V7C2.5 6.5 2.9375 6 3.5 6H10.375L11.625 2.6875C11.75 2.3125 12.125 2 12.5625 2H20.75ZM20.75 0H12.5625C11.3125 0 10.1875 0.8125 9.75 2L9 4H3.5C1.8125 4 0.5 5.375 0.5 7V25C0.5 26.6875 1.8125 28 3.5 28H29.5C31.125 28 32.5 26.6875 32.5 25V7C32.5 5.375 31.125 4 29.5 4H24L23.0625 1.625C22.6875 0.6875 21.8125 0 20.75 0ZM16.5 23.5C20.625 23.5 24 20.1875 24 16C24 11.875 20.625 8.5 16.5 8.5C12.3125 8.5 9 11.875 9 16C9 20.1875 12.3125 23.5 16.5 23.5ZM16.5 10.5C19.5 10.5 22 13 22 16C22 19.0625 19.5 21.5 16.5 21.5C13.4375 21.5 11 19.0625 11 16C11 13 13.4375 10.5 16.5 10.5Z",
    fill: "#605FF3"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPicture, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/picture.221eee86.svg";
export { ForwardRef as ReactComponent };